import { useState } from 'react';
import { makeStyles, Button, Typography } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import UserEditModal from './shared/UserModals/UserEditModal';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2.5),
    padding: theme.spacing(1, 1.5),
    backgroundColor: 'rgba(102, 126, 234, 0.08)',
    borderRadius: 10,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: 'rgba(102, 126, 234, 0.12)',
    },
  },
  userAvatar: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: 16,
    fontWeight: 600,
    flexShrink: 0,
  },
  userDetails: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0, // Important for text truncation
    overflow: 'hidden',
  },
  userName: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colors?.blue2 || '#122056',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 220, // Increased maximum width
  },
  userEmail: {
    fontSize: 13,
    color: '#666',
    lineHeight: 1.2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 220,
  },
  editButton: {
    textTransform: 'none',
    borderRadius: 8,
    minWidth: 36,
    width: 36,
    height: 36,
    padding: theme.spacing(0.75),
    marginLeft: theme.spacing(1.5),
    flexShrink: 0,
    '&:hover': {
      backgroundColor: 'rgba(102, 126, 234, 0.08)',
    },
  },
}));

const CompactUserInfo = ({ userData, onUserUpdate, accountUuid, showEditButton = true }) => {
  const classes = useStyles();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleOpenEditModal = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = (hasUserBeenUpdated) => {
    setIsEditModalOpen(false);
    if (hasUserBeenUpdated && onUserUpdate) {
      // Handle user update if needed
    }
  };

  const handleUserSave = (updatedUserData) => {
    if (onUserUpdate) {
      onUserUpdate(updatedUserData);
    }
  };

  if (!userData) {
    return null;
  }

  return (
    <>
      <div className={classes.container}>
        <div className={classes.userAvatar}>
          {userData?.firstName?.[0]?.toUpperCase()}
          {userData?.lastName?.[0]?.toUpperCase()}
        </div>
        <div className={classes.userDetails}>
          <Typography className={classes.userName}>
            {userData?.firstName} {userData?.lastName}
          </Typography>
          <Typography className={classes.userEmail}>
            {userData?.email}
          </Typography>
        </div>
        {showEditButton && (
          <Button
            variant="outlined"
            color="primary"
            className={classes.editButton}
            onClick={handleOpenEditModal}
          >
            <EditIcon fontSize="default" />
          </Button>
        )}
      </div>

      {showEditButton && (
        <UserEditModal
          open={isEditModalOpen}
          handleClose={handleCloseEditModal}
          userData={userData}
          accountUuid={accountUuid}
          onSave={handleUserSave}
        />
      )}
    </>
  );
};

export default CompactUserInfo;
